/*
 [CheckTableIterator]: An iterator over a CheckTable.
 Methods
 hasNext: determine if there is another row available.
 next: get a CheckRow for current row and iterate to the next.  If the current row is not a valid CheckRow it will return null.
 */
export function CheckTableIterator(checkTableObject) {
    this.checkTableObject = checkTableObject;
    this.rows = checkTableObject.tableElm.getElementsByTagName("tr");

    this.hasNext = function() {
        return this.curRow < this.rows.length;
    };

    this.next = function() {
        // get the id string of the row element
        let rowIDStr = this.rows[this.curRow].id;
        this.curRow++;
        if (rowIDStr.indexOf(this.checkTableObject.rowPrefix) === 0
            && rowIDStr.length > this.checkTableObject.rowPrefix.length
        ) {
            // and has more characters for the id?
            // parse the row ID out of this string  (format is rowPrefix followed by the row ID)
            let id = rowIDStr.substring(this.checkTableObject.rowPrefix.length);
            return this.checkTableObject.getRow(id);
        } else return null;
    };

    this.curRow = 0;
}